module.exports = "<xeli-admin-sidebar></xeli-admin-sidebar>\n<main id=\"content\" class=\"main\" role=\"main\">\n  <router-outlet></router-outlet>\n</main>\n"